module.exports = __webpack_public_path__ + "static/media/blog1cover.a2fbb59a.webp";